import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-mat-action-row-personnalised',
  templateUrl: './mat-action-row-personnalised.component.html',
  styleUrls: ['./mat-action-row-personnalised.component.scss']
})
export class MatActionRowPersonnalisedComponent implements OnInit {

  constructor() { }

  @Input() firstStep: number //The size of the columns of the grid

  @Input() disabled: string //The page in which we show the product grid

  ngOnInit(): void {
  }


}
